import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/admin_withdraw_applications',
  component: Management,
  redirect: '/admin_withdraw_applications/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/admin_withdraw_applications/List'),
      meta: {
        auth: Auth.listAdminWithdrawApplications
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/admin_withdraw_applications/DetailLayout'),
      meta: {
        auth: Auth.showAdminWithdrawApplication
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/admin_withdraw_applications/details/Detail'),
          meta: {
            auth: Auth.showAdminWithdrawApplication
          }
        }
      ]
    }
  ]
}
